module.exports = __webpack_public_path__ + "img/monyback-gold.9a705c30.svg";